const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SecretPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSecret extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Toggle the minimum input length for search queries - ex: either 0 or 2
	 * Used to make it easier to search for samples, etc. when server-side searching is enabled
	 * @param {Number} pValue - The value to set the minimum input length to
	 * @return {void}
	 */
	toggleMinimumInputLengthForSearch(pValue)
	{
		// set the minimum input length for search queries
		this.pict.views.HeadlightPanels.MinimumInputLengthForSearch = pValue || 0;
		// re-render the search view to update the search input field
		this.pict.PictApplication.changeTheme('Edit');
	}

	handleDocumentRefreshAndDownload(event)
	{
		if (event)
		{
			// set the button to be loading
			event.target.classList.add('is-loading', 'is-dark', 'button');
		}
		// download the pdf with the forced refresh flag set
		this.pict.providers.DocumentProvider.handleDocumentDownload(true, null, () =>
		{
			event.target.classList.remove('is-loading', 'is-dark', 'button');
		});
	}
}

module.exports = HeadlightPaneSecret;

module.exports.default_configuration = _ViewConfiguration;
